<template>
  <div class="TokenAIComic">
    <div class="page_title">
      <el-divider>
        <div class="page_title_name">AI漫剧生成</div>
      </el-divider>
    </div>
    <div class="page_content">
      <p class="page_content_text">AI 漫剧生成平台是面向二次元与网文改编的智能创作工具，集成剧本拆解、分镜生成、角色设计、配音字幕及视频合成等全流程能力。输入文字即可快速生成国漫、古风、都市等风格的漫剧内容，保障角色形象与画风统一。无需专业技能，大幅降低制作门槛与成本、缩短周期，适配短视频、IP 改编、网文变现等场景，是个人创作者与工作室高效产出漫剧的核心工具。</p>
      <el-button class="page_content_btn" @click="goToPlatform">进入平台</el-button>
      <img class="page_content_img" src="../../assets/qingye/ai-comic-homepage.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "TokenAIComic",
  data() {
    return {
      platformUrl: "https://film.aobaai.com",
    };
  },
  methods: {
    goToPlatform() {
      window.open(this.platformUrl, "_blank");
    },
  },
};
</script>
<style scoped>
.TokenAIComic {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.page_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  text-align: center;
  padding-bottom: 20px;
}
.page_title_name {
  font-weight: 600;
  font-size: 26px;
  text-align: center;
}
.page_content {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}
.page_content_text {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
  text-indent: 2em;
}
.page_content_btn {
  align-self: center;
  margin-bottom: 20px;
  background-color: #2968BD;
  border-color: #2968BD;
  color: #fff;
  border-radius: 4px;
  padding: 12px 32px;
}
.page_content_btn:hover {
  background-color: #1e4f8f;
  border-color: #1e4f8f;
  color: #fff;
}
.page_content_img {
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Token/AIComic.vue